export function normalizeBrowserUrl(input: string, baseUrl: string): string {
  const value = input.trim();
  if (!value) return baseUrl;

  if (/^https?:\/\//i.test(value)) return value;
  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/.*)?$/i.test(value)) {
    return `https://${value}`;
  }

  try {
    return new URL(value, baseUrl).toString();
  } catch {
    return baseUrl;
  }
}
